// binding.schema.json source — `<mission_workspace>/.claude/state/
// autopilot-binding.json` (spec §6.2 "Binding (1.4)"). MUST match the exact
// field set already written by `autopilot-binding-file-writer.ts` (P1/P2,
// shipped and tested) — this schema is the validation contract for that
// existing writer's output, not a new shape. Field list cross-checked
// against `writeAutopilotBindingFile`'s `bodyWithoutChecksum` object:
// schema_version, mission_id, ticket_id, run_id, session_id, issued_at,
// expires_at, repo_root, allowed_paths, allowed_tools, checksum.
//
// `kind` is documented by the phase file's binding.schema.json field list
// ("mission/ticket/run id, kind, allowed_paths, capabilities, issued_at/
// expires_at, hash") but the current writer does not emit it yet — kept
// optional here so this schema validates today's real file AND the P1 spec
// field list without inventing a stricter contract than what P1/P2 ship.
import { z } from "zod";

export const BindingSchema = z
  .object({
    schema_version: z.literal(1),
    mission_id: z.string().min(1),
    ticket_id: z.string().min(1),
    run_id: z.string().min(1),
    session_id: z.string().min(1),
    issued_at: z.string().min(1),
    expires_at: z.string().min(1),
    repo_root: z.string().min(1),
    allowed_paths: z.array(z.string()),
    allowed_tools: z.array(z.string()),
    kind: z.string().optional(),
    checksum: z.string().regex(/^[0-9a-f]{64}$/i),
  })
  .strict();

export type Binding = z.infer<typeof BindingSchema>;
